import React from "react";

interface PageLayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showNavigation?: boolean;
  headerTitle?: string;
  onSearchClick?: () => void;
  onCartClick?: () => void;
  className?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  className = "",
}) => {
  return (
    <div
      className={`h-screen-dvh bg-white flex flex-col overflow-hidden ${className}`}
    >
      {children}
    </div>
  );
};

export default PageLayout;
